import { getsertStoredUUID } from 'scripts/helpers/Utils'

export default class AppContext {
  constructor() {
    this.location = window.location
  }

  getParams() {
    return {
      t_ms: this.getTimestamp(),
      uuid: this.getUUID(),
      user_agent: this.getUserAgent(),
      url: this.getFullPath(),
      app_id: __SERVER_VAR_VIKILITICS_ID__ // eslint-disable-line no-undef
    }
  }

  getTimestamp() {
    return Date.now()
  }

  getUUID() {
    return getsertStoredUUID()
  }

  getUserAgent() {
    return window.navigator.userAgent
  }

  protocol() {
    return window.location.protocol
  }

  getLocation() {
    return window.location
  }

  getFullPath() {
    return window.location.href
  }

  device() {
    return 'desktop'
  }

  appId() {
    return window.appId || ''
  }

  appVer() {
    return window.appVersion || ''
  }

  videoId() {
    return window.videoId || ''
  }

  containerId() {
    return window.containerId || ''
  }

  isBlocked() {
    return window.isBlocked || false
  }

  isAdBlockOn() {
    // logic for checking AdBlock here
    return false
  }

  currentPage() {
    // logic for getting currentPage
    return null
  }

  prevPage() {
    // logic for getting prevPage
    return null
  }

  referrer() {
    return document.referrer
  }

  flashVersion() {
    return null
  }

  vikiCookieDomain() {
    return null
  }

  interfaceLanguage() {
    return null
  }
}



// WEBPACK FOOTER //
// ./assets/js/lib/Vikilitics/AppContext.js